import { isPlatformServer } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { makeStateKey } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-illustration-collection",
  templateUrl: "./illustration-collection.component.html",
  styleUrls: ["./illustration-collection.component.scss"],
})
export class IllustrationCollectionComponent implements OnInit {
  id = "";
  cate = "";
  collectionData: any = {};
  collectionsFiles: any = [{},{},{},{},{},{},{},{}];
  visibleCollectionsFiles: any[] = [{},{},{},{},{},{},{},{}];   // rendered data
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;

  illusData: any = {};
  ILLUS_KEY = makeStateKey<any>("illusData");
  loader = true;
  imageLoad = true;
  constructor(
    private afs: AngularFirestore,
    public router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.route.queryParams.subscribe((params) => {
    //   this.id = params["slug"];
    //   //console.log(params);
    //   //console.log(this.id);

    //   // })
    //   // this.route.params.subscribe((params) => {
    //   // this.id = params["id"];
    //   // this.cate = params["cate"];

    //   //console.log(this.id);
    //   //console.log(this.cate);
    //   //console.log(params);

    //   if (this.id) {
    //     // this.getSingleService(this.id).then((data) => {
    //     //   data.subscribe((singleservice) => {
    //     //     //console.log(singleservice);
    //     //     this.collectionData = singleservice[0];
    //     //     this.collectionData?.collectionName ? this.getCollectionFileData() : null;
    //     //   });
    //     // });
    //   }
    // });
  }

  getSEOImage(url: string): string {
      return buildSEOImageUrl(url);
    }

  ngOnInit(): void {
    this.collectionData = this.route.snapshot.data["illustration"];

    if(this.collectionData?.slug) {  
      this.getCollectionFileData();
    }
    // this.id = this.illusData?.id;
    // this.titleStr = this.route.snapshot.paramMap.get("slug");
    //console.log("this.illusData", this.collectionData);
    const isServer = isPlatformServer(this.platformId);
    //console.log("isServer (ngOnInit):", isServer);
  }

  async getCollectionFileData() {
    //console.log("getCollectionFileData called");
    this.collectionsFiles = [];
    const get = await this.afs.collection(`filesMaster/`, (res) => {
      return this.cate
        ? res
            .where("collections", "==", this.collectionData?.collectionName)
            .where("categories", "array-contains", this.cate)
            .where("status", "==", "Published")
        : res
            .where("collections", "==", this.collectionData?.collectionName)
            .where("status", "==", "Published");
    });

    const getdata = await get.valueChanges({ idField: "id" });
    getdata.subscribe((fdata) => {
      this.collectionsFiles = fdata;

    this.loader = false;
    this.imageLoad = false;
    this.initIllusLoad();   // ✅ after data assignment
      //console.log(this.collectionsFiles);
    });
  }

  async getSingleService(id) {
    // const get = await this.afs.collection(`collectionMaster/`, (res) => {
    //   return res.where("collectionName", "==", id).orderBy("createdOn", "desc");
    // });
    // const getdata = await get.valueChanges();
    // return getdata;
  }

    initIllusLoad() {
    this.currentPage = 1;
    this.visibleCollectionsFiles = this.collectionsFiles.slice(0, this.pageSize);
  }

   loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleCollectionsFiles = this.collectionsFiles.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

    get hasMoreIllus(): boolean {
    return this.visibleCollectionsFiles.length < this.collectionsFiles.length;
  }
}
